import React from "react";
import ResourceEditor from "./ResourceEditor";
import { resolveImageUrl } from "./ImageUpload";

const HomeDancesAdmin = () => (
  <ResourceEditor
    resource="home_dances"
    title="Section « Une danse pour chacun » (page d'accueil)"
    subtitle="Cartes de disciplines mises en avant sur la page d'accueil, sous les professeurs. Vous pouvez ajouter, réordonner, éditer ou supprimer chaque carte."
    fields={[
      { key: "name", label: "Nom de la discipline", placeholder: "Ex: Danse Classique" },
      { key: "ageRange", label: "Public / tranche d'âge", placeholder: "Ex: 7 ans à adultes" },
      { key: "description", label: "Description courte", type: "textarea", placeholder: "Description affichée sur la carte" },
      { key: "image", label: "Image (URL ou upload)", type: "image", placeholder: "URL ou upload d'image" },
      { key: "link", label: "Lien au clic sur la carte", placeholder: "/cours-tenues" },
    ]}
    emptyItem={{ name: "", ageRange: "", description: "", image: "", link: "/cours-tenues" }}
    renderPreview={(d) => (
      <div className="flex gap-3 items-start min-w-0">
        {d.image && (
          <img src={resolveImageUrl(d.image) || d.image} alt="" className="w-16 h-16 rounded-lg object-cover flex-shrink-0" />
        )}
        <div className="min-w-0 flex-1">
          <div className="font-serif-display text-stone-800">{d.name || "(sans titre)"}</div>
          <div className="text-stone-500 text-xs">
            {d.ageRange || "—"}{d.link ? ` · ${d.link}` : ""}
          </div>
          {d.description && (
            <div className="text-stone-600 text-xs mt-1 line-clamp-2">{d.description}</div>
          )}
        </div>
      </div>
    )}
  />
);

export default HomeDancesAdmin;
